// Funções puras da Campanha Inteligente no cardápio.
//
// As ofertas do cliente chegam como uma PROMOÇÃO SINTÉTICA (is_daily_offer) no
// formato de `promotions`. Juntando-a às promoções fixas, card, popup, pizza,
// carrinho, cupom e cashback aplicam o desconto sem código novo de preço.
import { medidaDoItem } from "../../lib/unidadeVenda";

const arred = (v) => Math.round(Number(v || 0) * 100) / 100;

export const normalizarTamanho = (nome) =>
  String(nome || "").trim().toLowerCase().split(/\s+/).filter(Boolean).join(" ");

/** Unidades da oferta já usadas no carrinho, por chave. Linha por quilo/litro
 *  conta 1 unidade (30/09/2026, regra igual à do servidor): 1,25 kg de uma
 *  oferta "1 por dia" leva o desconto na linha inteira. `produtos` (opcional):
 *  cadastro, quando o item do carrinho não traz sale_unit/is_divisible. */
export function unidadesDoItemNaOferta(it, produtos) {
  return medidaDoItem(it, produtos) ? 1 : Number(it?.quantity || 0);
}

export function unidadesPorChave(cart, produtos) {
  const usadas = {};
  for (const it of cart || []) {
    if (it?.oferta_chave) usadas[it.oferta_chave] = (usadas[it.oferta_chave] || 0) + unidadesDoItemNaOferta(it, produtos);
  }
  return usadas;
}

// Promoções fixas + a sintética. Produto que já tem no carrinho as unidades do
// limite sai da sintética: a próxima unidade entra no preço normal.
export function mesclarPromocoes(fixas, ofertasDia, cart, produtos) {
  const base = fixas || [];
  if (ofertasDia?.estado !== "ativo" || !ofertasDia.promocao) return base;
  const limite = ofertasDia.config?.limite_unidades || 1;
  const usadas = unidadesPorChave(cart, produtos);
  const products = (ofertasDia.promocao.products || []).filter((pp) =>
    pp.sizes ? true : (usadas[`p:${pp.product_id}`] || 0) < limite);
  if (products.length === 0) return base;
  return [...base, { ...ofertasDia.promocao, products }];
}

// O que o card de um produto mostra: oferta com valor, marcado sem valor, ou nada.
export function ofertaDoProduto(ofertasDia, productId) {
  if (!ofertasDia || !productId) return null;
  if (ofertasDia.estado === "ativo") {
    const lista = ofertasDia.porProduto?.get(String(productId));
    if (!lista || lista.length === 0) return null;
    return {
      tipo: "oferta",
      pct: Math.max(...lista.map((o) => o.pct)),
      varios: lista.length > 1,
      chave: lista[0].chave,
    };
  }
  if ((ofertasDia.estado === "anonimo" || ofertasDia.estado === "bloqueado")
      && ofertasDia.marcados?.has(String(productId))) {
    return { tipo: "marcado", chave: `m:${productId}` };
  }
  return null;
}

const CAMPOS_OFERTA = ["oferta_chave", "oferta_dia", "oferta_desconto_unit", "oferta_acumula_cashback", "oferta_acumula_cupom"];

function marcaPizza(item, ofertasDia, sintetica) {
  const tam = normalizarTamanho(item.pizza.size_name);
  const sabores = item.pizza.flavor_ids || [];
  const fid = sabores.find((f) => ofertasDia.porChave?.has(`z:${f}:${tam}`)
    && (sintetica.products || []).some((pp) => pp.product_id === f && pp.sizes));
  if (!fid) return null;
  const o = ofertasDia.porChave.get(`z:${fid}:${tam}`);
  // Desconto unitário só é exato com um sabor; com dois, a regra do sabor mais caro decide.
  return { oferta_chave: o.chave, oferta_desconto_unit: sabores.length === 1 ? arred(o.preco_cheio - o.preco_oferta) : null };
}

function marcaProduto(item, ofertasDia, sintetica) {
  if (!(sintetica.products || []).some((pp) => pp.product_id === item.id && !pp.sizes)) return null;
  const o = ofertasDia.porChave?.get(`p:${item.id}`);
  if (!o) return null;
  const combo = item.combo_type === "combo" && o.preco_combo;
  const unit = combo ? o.preco_combo - o.preco_combo_oferta : o.preco_cheio - o.preco_oferta;
  return { oferta_chave: o.chave, oferta_desconto_unit: arred(unit) };
}

// Marca o item que entra no carrinho com a oferta que o preço dele usou.
export function marcarOferta(item, ofertasDia, promocoesAtivas) {
  const limpo = { ...item };
  CAMPOS_OFERTA.forEach((k) => { delete limpo[k]; });
  if (ofertasDia?.estado !== "ativo") return limpo;
  const sintetica = (promocoesAtivas || []).find((p) => p.is_daily_offer);
  if (!sintetica) return limpo;
  const marca = item.pizza ? marcaPizza(item, ofertasDia, sintetica) : marcaProduto(item, ofertasDia, sintetica);
  if (!marca) return limpo;
  return {
    ...limpo, ...marca,
    oferta_dia: ofertasDia.dia,
    oferta_acumula_cashback: !!ofertasDia.config?.acumula_cashback,
    oferta_acumula_cupom: !!ofertasDia.config?.acumula_cupom,
  };
}

export function textoDaFaixa(ofertasDia) {
  const n = ofertasDia?.total || 0;
  const modelo = ofertasDia?.config?.texto_faixa || "Você tem {n} ofertas exclusivas hoje, espalhadas pelo cardápio";
  return modelo.replace("{n}", String(n));
}
